<template>
  <v-layout>

    <v-dialog v-bind:value="dialog" @click:outside="$emit('updateDialog', false)" max-width="500px">

      <v-card>
        <v-form v-on:submit.prevent="createItem">
          <v-card-title>
            <span class="headline">{{ modal_title }}</span>
          </v-card-title>

          <v-card-text>
            <!-- START FORM DIALOG -->
            <div class="row">
              <div class="col-md-12">
                <v-text-field data-vv-as="nombre" label="Nombre*" name="name" v-model="item.name"
                  v-validate="'required'" :disabled="isViewModal()"></v-text-field>
                <span class="red--text">{{ errors.first("name") }}</span>
              </div>
              <div class="col-md-12 mt-3">
                <v-menu v-model="colorPickerMenu" :close-on-content-click="false" offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="item.color" label="Color" readonly v-bind="attrs" v-on="on"
                      :disabled="isViewModal()" :style="{ color: item.color }">
                      <!-- Icono personalizado con color dinámico -->
                      <template v-slot:prepend-inner>
                        <v-icon :style="{ color: item.color }">mdi-palette</v-icon>
                      </template>
                    </v-text-field>
                  </template>

                  <v-card>
                    <v-color-picker v-model="item.color" hide-canvas hide-inputs show-swatches swatches-max-height="150"
                      mode="hexa" />
                    <v-card-actions>
                      <v-spacer />
                      <v-btn text @click="colorPickerMenu = false">Cerrar</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-menu>

              </div>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="$emit('updateDialog', false)">Cerrar</v-btn>
            <v-btn color="success" text type="submit" v-if="!isViewModal()" :loading="loading">{{ formBtn }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import ModalGenericMixin from "@/mixins/ModalGenericMixin.vue";

export default {
  mixins: [ModalGenericMixin],
  props: {
    service: Object,
    modal_title: String,
    dialog: Boolean,
    item: Object,
    formBtn: String,
    selectedFolder: Object,
  },
  data() {
    return {
      show: false,
      colorPickerMenu: false,
    };
  },
  watch: {
    item() {
      this.$emit("updateItem", this.item);
    },
    dialog() {
      this.errors.clear();
    },
  },
  mounted() { },
  methods: {
    isViewModal() {
      return this.formBtn == "";
    },

    createItem(e) {
      if (this.loading) return;
      this.$validator.validate().then((valid) => {
        if (valid) {
          e.preventDefault();

          this.loading = true;

          const data = {
            id: this.item.id,
            name: this.item.name,
            color: this.item.color,
            folder_parent: this.selectedFolder ? this.selectedFolder.id : null,
          }

          if (this.item.id > 0) {
            this.service
              .update(data)
              .then((response) => {
                if (response.status == true) {
                  this.$toast.success("El " + this.modal_title + " se modifico correctamente.", "OK");
                  this.$emit("updateDialog", false);
                  this.$emit("loadList");
                } else {
                  if (Object.prototype.hasOwnProperty.call(response, "message")) {
                    this.$toast.error(response.message, "Error");
                  } else {
                    this.$toast.error(response.msg, "Error");
                  }
                }
              })
              .catch((response) => {
                this.$toast.error(response.msg, "Error");
              })
              .finally(() => (this.loading = false));
          } else {
            this.service
              .create(data)
              .then((response) => {
                console.log(response);
                if (response.status) {
                  this.$toast.success("El " + this.modal_title + " se creo correctamente", "OK");
                  this.$emit("updateDialog", false);
                  this.$emit("loadList");
                } else {
                  if (Object.prototype.hasOwnProperty.call(response, "message")) {
                    this.$toast.error(response.message, "Error");
                  } else {
                    this.$toast.error(response.msg, "Error");
                  }
                }
              })
              .catch((response) => {
                console.log(response);
                this.$toast.error(response.msg, "Error");
              })
              .finally(() => (this.loading = false));
          }
        }
      });
    },
  },
};
</script>
